import React from "react";
import PropTypes from "prop-types";
import * as Table from "reactabular-table";
import { injectIntl, intlShape } from "react-intl";

import { genComponentFormatterLong } from "../model/util/Components";

import { formatSecondsAsDuration } from "./AnalyseTools";

import { genDailyMessage } from "./DailyValuesHelpers";
import { checkDailyProps } from "../model/util/DailyValues";

const genSecondsAsDurationFormatter = intl => {
	return value => formatSecondsAsDuration(value, intl);
};

class LastLeerlaufTabelle extends React.Component {
	
	static propTypes = {
		model: PropTypes.object.isRequired,
		timespan: PropTypes.object.isRequired,
		rtc: PropTypes.string.isRequired,
		compressors: PropTypes.arrayOf(PropTypes.object).isRequired,
		units: PropTypes.object.isRequired,
		intl: intlShape.isRequired,
		refresh: PropTypes.func.isRequired
	};
	
	constructor(props, context) {
		super(props, context);
		this.state = {};
		checkDailyProps(props);
	}
	componentWillReceiveProps(nextProps) {
		checkDailyProps(nextProps);
	}
	render() {
		const { model, compressors, intl } = this.props;
		return (
			<div>
				<Table.Provider
					className="printableAlmigItem"
					columns={[{
						property: "cindex",
						cell: { formatters: [ genComponentFormatterLong(compressors, intl) ] },
						header: {
							label: intl.formatMessage({ id: "Component" })
						}
					}, {
						property: "lastlauf_s",
						cell: { formatters: [ genSecondsAsDurationFormatter(intl) ]},
						header: {
							label: intl.formatMessage({ id: "Load" })
						}
					}, {
						property: "leerlauf_s",
						cell: { formatters: [ genSecondsAsDurationFormatter(intl) ]},
						header: {
							label: intl.formatMessage({ id: "No-load" })
						}
					}]}>
					<Table.Header />
					<Table.Body rows={model.data} rowKey="cindex" />
				</Table.Provider>
				{genDailyMessage(model)}
			</div>
		);
	}
}

export default injectIntl(LastLeerlaufTabelle);
